export const getMenuItems = () => {
  // Items do menu ação
  return [
    { key: "1", label: "Validar" },
    { key: "2", label: "Editar" },
    { key: "3", label: "Excluir" },
  ];
};
